<template>
<div>
  <div class="popBg" @click="findOut"></div>

  <div class="popup fixed">
    <div class="popup__inner fixed z-40 py-5 px-8 bg-white max-w-xs">
      <div class="popup__header text-NotoSansRegular" v-if="$store.state.alert.isHead">
        <span>提示訊息</span>
      </div>
      <div class="popup__body text-NotoSansRegular textColorDarkBlack flex">
        <p class="mt-1 w-8 pr-1">
          <img src="@/assets/icon/Shape.png" alt="alert" class="object-contain" v-if="$store.state.alert.type === 'alert'">
          <img src="@/assets/icon/warning.png" alt="warning" class="object-contain" v-if="$store.state.alert.type === 'warning'">
          <img src="@/assets/icon/check_circle.png" alt="check_circle" class="object-contain" v-if="$store.state.alert.type === 'check'">
        </p>
        <p>{{ $store.state.alert.alertMsg }}</p>
      </div>
      <div class="popup__buttons">
        <a class="py-3 rounded-full textColorDarkBlack btn btn--small popup__ok cursor-pointer hover:text-white text-NotoSansRegular"
          @click="findOut">
          確定
        </a>
      </div>
    </div>
  </div>

</div>
</template>

<script>
export default {
  name: 'AlertInform',

  data () {
    return {
    }
  },

  methods: {
    findOut () {
      let self = this
      self.$store.dispatch('updateAlert', { isAlert: false, isHead: true, alertMsg: '尚未登入', type: 'alert' })
    }
  }
}
</script>

<style lang="scss" scoped>
.popBg {
  width: 100%;
  height: 100vh;
  top: 0;
  left: 0;
  position: fixed !important;
  background-color: rgba(0, 0, 0, 0.6);
  z-index: 100;
}
.popup {
  z-index: 1000;
  .popup__inner {
    top: 45%;
    left: 0;
    right: 0;
    margin: 0 auto;
    line-height: 1.5;
    letter-spacing: .05em;
    -webkit-box-sizing: border-box;
    -moz-box-sizing: border-box;
    box-sizing: border-box;
    // box-shadow: 8px 8px 8px rgba(0, 0, 0, 0.25);
    border-radius: 4px;

    -webkit-transform: scale(0.3);
    -moz-transform: scale(0.3);
    -ms-transform: scale(0.3);
    -o-transform: scale(0.3);
    transform: scale(0.3);

    -webkit-animation-name: example;
    -webkit-animation-duration: .3s;
    animation-name: example;
    animation-duration: .3s;
    animation-fill-mode: forwards;
    .popup__header {
      margin-bottom: 15px;
      font-size: 0.85em;
      font-weight: bold;
      color: #1976D2;
      span {
        border-bottom: 1px solid #1976D2;
      }
    }
    .popup__body {
      margin: 15px 0;
      font-size: 0.85em;
    }
  .popup__buttons {
        text-align: right;
    .btn--small {
        line-height: 22px;
    }
    .btn {
      display: inline-block;
      border: 0;
      font-size: 11px;
      text-align: center;
      text-decoration: none;
      vertical-align: middle;
      height: auto;
      padding: 0.5rem 1rem;
      line-height: 1;
      background-color: #fff;
      border: 1px solid #646565;
      white-space: nowrap;
      transition: .3s;
      &:hover {
        background: #4B4B4B !important;
      }
      }
    }
  }
}
@-webkit-keyframes example {
  from {
    opacity: 0;
    margin-top: -77px;
    transform: scale(1);
  }
  to {
    opacity: 1;
    margin-top: -77px;
    transform: scale(1);
    }
}

/* Standard syntax */
@keyframes example {
  from {
    opacity: 0;
    margin-top: -77px;
    transform: scale(1);
  }
  to {
    opacity: 1;
    margin-top: -77px;
    transform: scale(1);
    }
}
</style>
